import axios from 'axios'
import { useContext, useState } from 'react'
import { TmpOrderContext } from '../../context api/TmpOrder/TmpOrderContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API, backendUrl, tmpOrderUrl } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useHistory } from 'react-router'
import { useAuthentication } from '../Authentication/useAuthentication'
import urlSearchParams from '../../components/urlSearchParams'
import { useDownload } from '../../hooks/Download/useDownload'

export const UseTmpOrder = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history= useHistory();
  // const [tmpOrders, setTmpOrders] = useState({})
  const { addTmpOrders, getAllTmpOrders, getTmpOrder, tmpOrders, addNewTmpOrder } = useContext(TmpOrderContext)
  const [loading, setLoading] = useState(false)
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();

  //CATEGORY
  const getAllTmpOrder = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_TMP_ORDERS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong in fetching  !', error)
        }
        // calling the context to set the state of all temp orders
        console.log(tmpOrders)
        // console.log(data.data)
        // console.log(getAllTmpOrders)
        getAllTmpOrders(data.data); 
        getPdfCsvData('GET_ALL_TMP_ORDERS', dto);
        // setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })
        //  false, loading: false })
        
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        } 
      })
  }

  const addTmpOrder = async (dto) => {
    setLoading(true)
    // await fileUpload({file:dto.image})
    await axios
      .post(API.ADD_TMP_ORDER, dto, header)
      .then((res) => {
        //console.log('DATA : ', data)
        setLoading(false)
        console.log(res.status)
        console.log("after error check")
        toastMessage('Order Added Successfully!!', success)
        addNewTmpOrder(res.data.data)
        history.push(ROUTES.MY_TMPORDERS)
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        console.log(error)
        if (err.response) {
          //console.log(err.response)
          console.log(err.responsea)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const editTmpOrder = async (dto, id)=>{
    setLoading(true)
    // console.log(API.EDIT_TMP_ORDER(id))
    await axios
      .put(API.EDIT_TMP_ORDER(id), dto, header)
      .then(({ status, data }) => {
        console.log("header", header)
        console.log('DATA : ', data)
        setLoading(false)
        console.log(status)
          // return toastMessage('Something Went Wrong !', error)
        // history.push(ROUTES.MY_TMPORDERS)

        // setTmpOrders(data.category)

        //  false, loading: false })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          console.log(err.responsea)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  
  const getSingleTmpOrder = (id) => {
    console.log("hello", id)
    let obj = {}
    tmpOrders.forEach((item)=>{
      console.log(item)
      if(item._id === id) obj=item;
    })
    return obj


  }

  const deleteAll = (dto = {}) => {
    setLoading(true)
    axios
      .post(API.DELETE_ALL_TMP_ORDERS, header)
      .then(({ status, data }) => {
        setLoading(false)
        // console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong in fetching  !', error)
        }
        // calling the context to set the state of all temp orders
        toastMessage('All Orders Deleted Successfully', success)
        console.log(tmpOrders)
        console.log(data.data)
        getAllTmpOrders([]); 
        history.push(ROUTES.ADD_TMP_ORDER)
        //  false, loading: false })
        
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
          
        } 
      })
  }

  const deleteMultiple = async (dto) => {
    setLoading(true)
    // await fileUpload({file:dto.image})
    await axios
      .post(API.DELETE_TMP_ORDERS, dto, header)
      .then(({ status, data }) => {
        console.log("header", header)
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        toastMessage('Order Deleted Successfully', success)
        getAllTmpOrder();
        history.push(ROUTES.ADD_TMP_ORDER)
        console.log(data.data);
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err, error)
        }
      })
  }
  return {
    getAllTmpOrder,
    addTmpOrder,
    editTmpOrder,
    getSingleTmpOrder,
    deleteAll,
    deleteMultiple,
    loading,
    pdfCsvData,
    setPdfCsvData
  }
}
